import { render, staticRenderFns } from "./onlineReview.vue?vue&type=template&id=4a3633a8&scoped=true"
import script from "./onlineReview.vue?vue&type=script&lang=js"
export * from "./onlineReview.vue?vue&type=script&lang=js"
import style0 from "./onlineReview.vue?vue&type=style&index=0&id=4a3633a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3633a8",
  null
  
)

export default component.exports